import axios from "axios";
import useJwt from "@/auth/jwt/useJwt";
import router from "@/router/index";
import store from "@/store";

const baseUrl = process.env.VUE_APP_API_URLv1;

let api = axios.create({
  baseURL: baseUrl,
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    if (!navigator.onLine) {
      // If offline, reject the request with an error
      return Promise.reject(new Error("No internet connection"));
    }
    const token = useJwt.getToken();
    const tenant = localStorage.getItem("userTenant");

    config.headers["Authorization"] = "Bearer " + token;
    config.headers["tenant"] = tenant;
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      this.clearCache();
      router.push({ name: "misc-session-expired" });
    }
    
    if (error.message === "Network Error") {
      return new Error("Request is too large to process!");
    }

    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      // Handle request timeout
      return Promise.reject(new Error("Request timed out. Please try again."));
    }
    return Promise.reject(error);
  }
);

export default api;
